import React from "react";
import { MapPin, Phone, Clock, Wrench, ShieldCheck, Star } from "lucide-react";
import { useSiteSettings } from "@/context/SiteSettingsContext";

const SERVICES = [
  "Battery replacement", "Camera repair", "Charge port repair",
  "Microphone/speaker repair", "Power button repair",
  "Screen repair/replacement", "Software problems",
  "Water-damage repair", "iPhone back glass replacement",
];

export default function About() {
  const { settings } = useSiteSettings();
  return (
    <div data-testid="about-page" className="mx-auto max-w-6xl px-4 sm:px-6 py-14">
      <p className="mono-label text-blue-400 mb-2">About us</p>
      <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-4">{settings.brand_name}, Hyderabad</h1>
      <p className="text-white/70 max-w-2xl leading-relaxed mb-10">
        {settings.about_intro}
      </p>

      <div className="grid gap-px sm:grid-cols-3 bg-white/10 border border-white/10 mb-14">
        <div className="bg-zinc-950 p-6">
          <MapPin className="h-5 w-5 text-blue-400 mb-3"/>
          <p className="mono-label text-white/50 mb-2">Store address</p>
          <p className="text-sm text-white/80 leading-relaxed">{settings.business_address}</p>
        </div>
        <div className="bg-zinc-950 p-6">
          <Phone className="h-5 w-5 text-blue-400 mb-3"/>
          <p className="mono-label text-white/50 mb-2">Call us</p>
          <a href={`tel:${(settings.business_phone || "").replace(/\s/g, "")}`} className="text-lg font-display hover:text-blue-400 transition-colors">{settings.business_phone}</a>
          <p className="text-xs text-white/50 mt-2 font-mono">Reply within 30 minutes</p>
        </div>
        <div className="bg-zinc-950 p-6">
          <Clock className="h-5 w-5 text-blue-400 mb-3"/>
          <p className="mono-label text-white/50 mb-2">Hours</p>
          <p className="text-sm">{settings.business_hours}</p>
          <div className="mt-3 flex items-center gap-1">
            {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 fill-yellow-500 text-yellow-500"/>)}
            <span className="text-xs text-white/60 ml-2">5.0 · 5 Google reviews</span>
          </div>
        </div>
      </div>

      <div className="grid gap-10 md:grid-cols-2 items-center">
        <div>
          <p className="mono-label text-blue-400 mb-3">In-store services</p>
          <h2 className="font-display text-2xl sm:text-3xl tracking-tight mb-4">What we repair at the store</h2>
          <ul className="grid grid-cols-2 gap-2 text-sm">
            {SERVICES.map((s) => (
              <li key={s} className="flex items-start gap-2 border border-white/10 bg-zinc-950 p-3">
                <Wrench className="h-4 w-4 text-blue-400 mt-0.5 shrink-0"/>{s}
              </li>
            ))}
          </ul>
        </div>
        <div className="border border-white/10 bg-zinc-950 overflow-hidden aspect-[4/3]">
          <img
            src="https://images.unsplash.com/photo-1550041473-d296a3a8a18a?crop=entropy&cs=srgb&fm=jpg&w=940"
            alt="Technician repairing smartphone"
            className="w-full h-full object-cover"
          />
        </div>
      </div>

      <div className="mt-14 border border-blue-500/30 bg-blue-600/5 p-6 flex items-start gap-4">
        <ShieldCheck className="h-6 w-6 text-blue-400 shrink-0 mt-0.5"/>
        <div>
          <p className="font-display text-lg">7-day replacement warranty on all displays</p>
          <p className="text-sm text-white/60 mt-1">Manufacturing defects covered. Physical damage after installation is excluded.</p>
        </div>
      </div>
    </div>
  );
}
